import { render } from "./LandingPage.vue?vue&type=template&id=7b4d45a2&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=7b4d45a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/static-apps/static-apps/src/jameda-desktop-opener/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4d45a2"]])

export default __exports__